<template>
  <!-- -->
  <div class="list-table"  :class="(showBorder? ' border': ' no-border') + (showShadow? ' shadow': ' no-shadow')" :style="{'background-color': backgroundColor}">
      <slot/>
  </div>
</template>

<script>

export default {
  props: {
    // 是否显示阴影
    showShadow: {default: true},
    // 是否显示边框
    showBorder: {default: false},
    backgroundColor: {default: "transparent"}
  },
  name: "",
  components: {
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
//@import "@/assets/css/el-tables";
.list-table{
  border-radius: 4px;
  overflow: auto;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  :deep(.el-table) {
    font-size: 12px;
    // table边框
    --el-table-border-color: var(--yq-border-color-2);
    // header背景色
    --el-table-header-bg-color: var(--yq-background-color);
    // 这个值是错误的，这样可以让table的表格边框不显示
    --el-table-border: var(--yq-border-color);
    .el-table__header{
      .el-table__cell{
        color: #333;
        font-size: 13px;
        .cell{
          border-right: 2px solid var(--yq-border-color);
        }
      }
    }
    .el-table__body td.el-table__cell{
      border-bottom: 1px solid var(--yq-border-color);
    }
    &.is-scrolling-middle{ // 当左右滚动时，固定列的边框不显示
      .el-table-fixed-column--left{
        .cell{
          border-right: none;
        }
      }
    }
  }
}
</style>